import { FC } from 'react';
import styled from 'styled-components';
import { MenuItem } from '@clds/menu-old';
import { getAnalyticsProp } from '@cld/analytics';
import { DropdownMenuItemWithLinkProps } from './DropdownMenuItem.types';
import { DropdownMenuItemContent } from './DropdownMenuItemContent';

export const DropdownMenuItemWithLink: FC<DropdownMenuItemWithLinkProps> = ({
  leftSlot,
  rightSlot,
  children,
  LinkComponent = 'a',
  analyticsMessage,
  analyticsAction = 'navigate',
  secondaryContent,
  menuItemProps,
  ...rest
}) => {
  const analyticsProp = getAnalyticsProp(analyticsMessage, analyticsAction);

  return (
    <StyledMenuItem {...analyticsProp} {...menuItemProps}>
      <LinkComponent {...rest}>
        <DropdownMenuItemContent leftSlot={leftSlot} rightSlot={rightSlot} secondaryContent={secondaryContent} children={children} />
      </LinkComponent>
    </StyledMenuItem>
  );
};

const StyledMenuItem = styled(MenuItem)`
  > a {
    text-decoration: none !important;
  }
`;
